import { useTranslation } from 'next-i18next';
import { Dispatch, SetStateAction } from 'react';
import Link from 'next/link';
import styles from '@components/SmallStoreCard/SmallStoreCard.styles';
import { IPointOfPresence } from '@features/checkout/typescript';
import sanitizeHtml from '@utils/sanitizeHtml';
import { getShowroomType, getOpeningHours, prepareShowroomUrl, navigationPossible, onClickNavigate } from '@utils/showroom';
import Button from '@components/Button/Button';
import MerchandisingDisplayStatus from '@components/MerchandisingDisplayStatus/MerchandisingDisplayStatus';
type TPropsType = {
  store: IPointOfPresence;
  isActive?: boolean;
  setActiveUuid?: Dispatch<SetStateAction<string>>;
  isDip?: boolean;
};
const SmallStoreCard = ({
  store,
  isActive = false,
  setActiveUuid,
  isDip = false
}: TPropsType) => {
  const {
    t
  } = useTranslation('common');
  const openingHours = store?.openingHours?.description ? getOpeningHours(store, t, true).replaceAll('\n', '<br/>') : '';
  return <>
      <button sx={styles.storeContainer(isActive, store?.merchandisingDisplayStatus === 'STATUS_AVAILABLE')} onClick={() => setActiveUuid ? setActiveUuid(store?.uuid || '') : null}>
        <div>
          <p className="caption bold">{getShowroomType(store?.group?.code, t)}</p>
        </div>
        <div sx={styles.addressContainer}>
          {store?.address && store?.address?.mallName && store?.address?.street && store?.address?.city && <p className="small">
              {store?.address?.city}, {store?.address?.mallName}, {store?.address?.street}, {store?.address?.postalCode}
            </p>}
          {store?.address && !store?.address?.mallName && store?.address?.street && store?.address?.city ? <p className="small">
              {store.address.city}, {store.address.street}, {store.address.postalCode}
            </p> : store?.address && !store?.address?.mallName && store?.address?.street && <p className="small">
                {store.address.street}, {store.address.postalCode}
              </p>}
        </div>
        <div>
          {store?.address && store?.address?.mallName && !store?.address?.street && <p className="small">
              {store.address.mallName}, {store.address.postalCode}
            </p>}
          {!isDip && <MerchandisingDisplayStatus store={store} isActive={isActive} />}
          {isActive && <div sx={styles.additionalInfo(true)}>
              <div sx={styles.darkGrey}>
                {store?.contact?.phones && store.contact.phones?.length > 0 && <p className="caption">
                    {t('callToStorePrefix')}{' '}
                    <a sx={styles.telLink} href={`tel:${store.contact.phones[0]}`}>
                      {store.contact.phones[0]}
                    </a>
                    {t('callToStoreSufix')}
                  </p>}
              </div>
              <p sx={styles.darkGrey} className="caption" dangerouslySetInnerHTML={sanitizeHtml(openingHours)} />
            </div>}
        </div>
        {isActive && store?.merchandisingDisplayDate && <div sx={{
        ...styles.right,
        ...styles.lightGrey
      }}>
            <p className="caption">
              {t('merchandisingDisplayDate', {
            date: store.merchandisingDisplayDate
          })}
            </p>
          </div>}
      </button>
      {isActive && store?.ids && Object.hasOwn(store.ids, 'INTERNAL-PIM-ID') && <div sx={styles.buttonsContainer}>
          <Link href={prepareShowroomUrl(store?.group?.code, store?.name, store?.ids['INTERNAL-PIM-ID'], t)}>
            <Button variant="link_underline" size="micro">
              {t('showroomDetails')}
            </Button>
          </Link>
          {navigationPossible(store?.location) && <Button variant="link_underline" size="micro" onClick={() => onClickNavigate(store?.location)}>
              {t('button.navigate')}
            </Button>}
        </div>}
    </>;
};
export default SmallStoreCard;